import { User } from '../../models'

export type UserProfileInfo = {
  displayName: string
  dob?: string
  isChild?: boolean
  firstName?: string
  lastName?: string
  lyraId?: string
}

export const createChildUserInfo = (childUsers: User[], isInternational: boolean): UserProfileInfo[] => {
  return childUsers.map((childUser: User) => {
    const userProfileInfo: UserProfileInfo = {
      firstName: childUser.firstname,
      lastName: childUser.lastname,
      displayName: isInternational
        ? `${childUser.lastname}, ${childUser.firstname}`
        : `${childUser.firstname} ${childUser.lastname}`,
      dob: childUser.dob,
      isChild: true,
      lyraId: childUser.lyraId,
    }
    return userProfileInfo
  })
}

export const createCSVDownload = function (data: BlobPart, filename: string) {
  const blob = new Blob([data], {
    type: 'text/csv;charset=utf-8;',
  })
  const url = URL.createObjectURL(blob)
  const link = window.document.createElement('a')
  link.setAttribute('href', url)
  link.setAttribute('download', filename)
  link.click()
  // Clean up the object URL to prevent memory leaks
  URL.revokeObjectURL(url)
}
